import { authStore } from '@/store/authStore'
import { configStore } from '@/store/configStore'
import axios from 'axios'

export function aSyncData (url, postData, options) {
    return new Promise((resolve, reject) => {
        const auth = authStore()
        const config = configStore()

        const fD = new FormData()
        fD.append('sessionID', auth.sessionID)

        for (const key in postData) {
            fD.append(key, postData[key])
        }

        axios.post(config.projectURL + url, fD, options)
            .then(r => {
                resolve(r)
            })
            .catch(e => {
                reject(e)
            })
    })
}

export function stringToDate(dateString){
    try {
        let arr = dateString.split(/[- :]/)
        return new Date(parseInt(arr[0]), parseInt(arr[1])-1, parseInt(arr[2]), parseInt(arr[3]), parseInt(arr[4]), parseInt(arr[5]))
    }catch (e) {
        console.log(e)
        return null
    }
}

export function dateToString(date){
    try {
        return date.getDate() + '.' + String(date.getMonth() +1).padStart(2, '0') + '.' + date.getFullYear() + ' ' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0') + ' Uhr '
    }catch (e) {
        console.log(e)
        return null
    }
}

export function calcDistance(lat1, lon1, lat2, lon2)
{
    let R = 6371;
    let dLat = toRad(lat2-lat1);
    let dLon = toRad(lon2-lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    let d = R * c;
    return d;
}

// Converts numeric degrees to radians
function toRad(Value)
{
    return Value * Math.PI / 180;
}

export function nl2br(str){
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2');
}